/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum NotificationTemplate {
  InspectionNotice = "InspectionNotice",
  InspectionCode = "InspectionCode",
  InspectionCancellationNotice = "InspectionCancellationNotice",
  PolicyCancelled = "PolicyCancelled",
}

export enum InspectionWizardStepEnum {
  BusinessInfo = "BusinessInfo",
  Operations = "Operations",
  Eligibility = "Eligibility",
  Classes = "Classes",
  Confirmation = "Confirmation",
}

export enum BusinessTypeEnum {
  SoleProprietor = "SoleProprietor",
  Partnership = "Partnership",
  JointVenture = "JointVenture",
  Trust = "Trust",
  LimitedLiabilityCompany = "LimitedLiabilityCompany",
  Corporation = "Corporation",
}

export type InspectionWizardVMBaseClass = BaseInspectionWizardVmBaseClass &
  BaseInspectionWizardVmBaseClassProductIdMapping<"1", RCIPInspectionWizardVM>;

export type InspectionRequestVMBaseClass = BaseInspectionRequestVmBaseClass &
  BaseInspectionRequestVmBaseClassProductIdMapping<
    "1",
    RCIPInspectionRequestVM
  >;

export interface Address {
  streetAddress?: string | null;
  suiteOrUnit?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
}

export interface AgencyInformation {
  agencyName?: string | null;
  agentName?: string | null;
  agencyEmail?: string | null;
  agencyPhone?: string | null;
  fax?: string | null;
}

export interface ClassStatement {
  classCode?: string | null;
  className?: string | null;
  classDescription?: string | null;
  eligibleStatement?: string | null;
  ineligibleStatement?: string | null;
}

export interface EligibilityStatements {
  programStatementSections?: ProgramStatementSection[] | null;
  classStatements?: ClassStatement[] | null;
}

export type HttpValidationProblemDetails = ProblemDetails & {
  errors?: Record<string, string[]> | null;
  [key: string]: any;
};

export interface InspectionContact {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phone?: string | null;
}

export interface InspectionWizardResponse {
  request?:
    | (BaseNull & BaseNullProductIdMapping<"1", RCIPInspectionRequestVM>)
    | null;
  wizard?:
    | (AbstractNull & AbstractNullProductIdMapping<"1", RCIPInspectionWizardVM>)
    | null;
}

export interface InsuredBusinessInformation {
  businessName?: string | null;
  primaryAddress?: Address;
  mailingAddress?: Address;
  businessType?: BusinessTypeEnum;
  mailingAddressSameAsPrimary?: boolean;
  contractorLicenseNumber?: string | null;
}

export interface MagicLinkResponse {
  businessName?: string | null;
  policyNumber?: string | null;
  productName?: string | null;
  maskedEmail?: string | null;
  isVerified?: boolean;
}

export interface MagicLinkVerifyRequest {
  /** @minLength 1 */
  code: string;
}

export interface Policy {
  policyNumber?: string | null;
  /** @format date */
  policyEffectiveDate?: string;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface ProgramStatementSection {
  statement?: string | null;
}

export type RCIPInspectionRequestVM = BaseInspectionRequestVmBaseClass & {
  descriptionOfOperations?: string | null;
  /** @format int32 */
  annualPayroll?: number | null;
  /** @format int32 */
  grossReceipts?: number;
  /** @format int32 */
  subcontractedCosts?: number;
  /** @format int32 */
  numberOfOwnersInField?: number | null;
  /** @format int32 */
  numberOfEmployees?: number;
  performNewConstruction?: boolean;
  usesDayLabor?: boolean;
  typeOfWorkPercentages?: TypeOfWorkPercentatges[] | null;
  eligibilityStatements?: EligibilityStatements;
};

export type RCIPInspectionWizardVM = BaseInspectionWizardVmBaseClass & {
  descriptionOfOperations?: string | null;
  /** @format int32 */
  numberOfOwnersInField?: number | null;
  /** @format int32 */
  numberOfEmployees?: number | null;
  performNewConstruction?: boolean | null;
  usesDayLabor?: boolean | null;
  eligibilityReviewed?: boolean;
  classesReviewed?: boolean;
  /** @format int32 */
  grossReceipts?: number | null;
  /** @format int32 */
  annualPayroll?: number | null;
  /** @format int32 */
  subcontractedCosts?: number | null;
  typeOfWorkPercentages?: TypeOfWorkPercentatges[] | null;
};

export interface TokenResponse {
  access_token?: string | null;
  token_type?: string | null;
  /** @format int32 */
  expires_in?: number;
}

export interface TypeOfWorkPercentatges {
  typeOfWork?: string | null;
  /** @format int32 */
  percentage?: number | null;
  /** @format int32 */
  payroll?: number;
}

interface BaseInspectionWizardVmBaseClass {
  currentStep?: InspectionWizardStepEnum;
  additionalDetails?: string | null;
  productId: number;
}

type BaseInspectionWizardVmBaseClassProductIdMapping<Key, Type> = {
  productId: Key;
} & Type;

interface BaseInspectionRequestVmBaseClass {
  clientInspectionId?: string | null;
  contact?: InspectionContact;
  policy?: Policy;
  insuredBusinessInformation?: InsuredBusinessInformation;
  agency?: AgencyInformation;
  productId: number;
}

type BaseInspectionRequestVmBaseClassProductIdMapping<Key, Type> = {
  productId: Key;
} & Type;

type BaseNull = {
  productId: number;
} | null;

type BaseNullProductIdMapping<Key, Type> = {
  productId: Key;
} & Type;

type AbstractNull = {
  productId: number;
} | null;

type AbstractNullProductIdMapping<Key, Type> = {
  productId: Key;
} & Type;

interface DiscriminatorNull {
  productId: number;
}

type DiscriminatorNullProductIdMapping<Key, Type> = {
  productId: Key;
} & Type;

interface InternalNull {
  productId: number;
}

type InternalNullProductIdMapping<Key, Type> = {
  productId: Key;
} & Type;
